import React from 'react';
// based on https://react-typescript-cheatsheet.netlify.app/docs/hoc/full_example
import TranslatorContext from './TranslatorContext';

interface WithTranslatorProps {
  t: (message: string) => string;
}

export function withTranslator<T extends WithTranslatorProps = WithTranslatorProps>(
  WrappedComponent: React.ComponentType<T>
) {
  const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  const ComponentWithTranslator = (props: Omit<T, keyof WithTranslatorProps>) => {
    return (
      <TranslatorContext.Consumer>
        {(contexts) => <WrappedComponent {...contexts} {...(props as T)} />}
      </TranslatorContext.Consumer>
    );
  };

  ComponentWithTranslator.displayName = `withTranslator(${displayName})`;

  return ComponentWithTranslator;
}
